import { IInfiniteQuery } from '../../../../api/use-infinite-query';
import { IOptionItemProps } from '../../../../components/common/Select/Select';
import { ILabel } from '../../../../components/Table/components/TableColumns/TableLabelBlock/TableLabelBlock';
import { ESubscriberIdActions } from '../../types';

export interface IManageNumberMeta {
    forwarding?: ISubscriberIdManageNumberRedirectionMeta;
    actions?: ESubscriberIdActions[];
    labels?: ILabel[];
    positionSelected?: IOptionItemProps;
}

export interface ISubscriberIdManageNumberRedirectionMeta {
    parameters: {
        noReplayPeriod: string[];
    };
    types: EManageNumberRedirection[];
}

export interface IManageNumberQuery extends IInfiniteQuery {
    subscriberId: string;
}

/*
* -------------------------------------------
*          Positions
* -------------------------------------------
*/


export interface IManageNumberPositionQuery {
    searchValue?: string;
    start?: boolean;
}

export interface IManageNumberCreatePositionQuery {
    name: string;
    subscriberId: string;
}

/*
* -------------------------------------------
*          Sim Card
* -------------------------------------------
*/

export interface IManageNumberSimCard {
    icc: string;
    puk1: string;
    puk2: string;
    simCardId: number;
}

export interface IManageNumberSimCardQuery {
    searchValue?: string;
    start?: boolean;
}

export interface IManageNumberSimCardUpdateResponse {
    orderId?: string;
    fieldErrors?: Array<{
        errorMessage: string;
        fieldName: string;
    }>;
}

export interface IManageNumberSimCardUpdateQuery {
    subscriberId: string;
    iccId: string;
    oldIccId?: string;
    oldSimCardId?: number;
}

/*
* -------------------------------------------
*          Redirection
* -------------------------------------------
*/

export interface IManageNumberRedirection {
    sec: number;
    msisdn: string;
    type: EManageNumberRedirection;
}

export interface IManageNumberRedirectionQuery {
    subscriberId: string;
    force?: boolean;
}

export enum EManageNumberRedirection {
    busy = 'BUSY',
    noAnswer = 'NO_ANSWER',
    nonavailability = 'NON_AVAILABILITY',
    unconditional = 'UNCONDITIONAL',
}

export interface IManageNumberRedirectionAdd {
    type: IOptionItemProps;
    time?: IOptionItemProps;
    phone: string;
}

export interface IManageNumberRedirectionAddQuery {
    subscriberId: string;
    item: IManageNumberRedirectionAdd;
}

export interface IManageNumberRedirectionRemoveQuery {
    subscriberId: string;
    item: IManageNumberRedirection;
}
